export const toast = {
    success,
    warning,
    error,
    info
}

export function success (message) {
    /*// eslint-disable-next-line
    M.toast({ html: message, classes: 'green lighten-4 grey-text text-darken-2' })*/
}

export function warning (message) {
    /*// eslint-disable-next-line
    M.toast({ html: message, classes: 'amber accent-1 grey-text text-darken-2' })*/
}

export function error (message) {
    /*// eslint-disable-next-line
    M.toast({ html: message, classes: 'orange darken-4 white-text' })*/
}

export function info (message) {
    /*// eslint-disable-next-line
    M.toast({ html: message, classes: 'light-blue lighten-4 grey-text text-darken-2' })*/
}
